<template>
  <div>
    <b-row class="d-flex align-items-center">
      <b-col
        :md="barCode ? 9 : 12"
        cols="12"
        class="d-flex flex-column"
      >
        <div
          v-if="!isBinanceID && !isRedotpayID"
          class="content-usdtWallet"
        >
          <label class="font-14">{{ $t('payment.USDT.labelWalletAddress', { value: 'USDT' }) }}</label>
          <p
            class="text-usdtWallet"
            data-testid="usdt-wallet-address"
          >
            {{ usdtWallet }}
            <b-img
              class="ml-1 cursor-pointer"
              fluid
              alt="img"
              data-testid="usdt-copy-wallet-address-btn"
              :src="require('@/assets/images/pages/payment/ic-copy.svg')"
              @click="handleCoppy"
            />
          </p>
        </div>
        <div
          v-else
          class="mb-1"
        >
          <p
            v-if="transfer.userName"
            class="mb-0"
          >
            <strong class="font-weight-700">{{ $t('common.labelName') }}:</strong> {{ transfer.userName }}
          </p>
          <p class="mb-0">
            <strong class="font-weight-700">{{ transfer.value }}: </strong>{{ transfer.add }}
            <b-img
              class="ml-1 cursor-pointer"
              fluid
              alt="img"
              data-testid="usdt-copy-wallet-address-btn"
              :src="require('@/assets/images/pages/payment/ic-copy.svg')"
              @click="handleCoppy"
            />
          </p>
        </div>
        <warning-notification
          v-if="!isAdSolutions"
          class="notification-refund-policy"
        >
          <template #content>
            <p class="m-0">
              ⚠️ {{ $t('payment.USDT.warningWalletAddress') }}
            </p>
          </template>
        </warning-notification>
      </b-col>

      <b-col
        v-if="barCode"
        class="text-center"
        md="3"
        cols="12"
      >
        <b-img
          class="qbarcode"
          fluid
          alt="img"
          :src="barCode"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BImg,
} from 'bootstrap-vue'
import { toastification } from '@core/mixins/toast'
import WarningNotification from '@/views/home/components/WarningNotification.vue'
import envMixin from '@/mixins/envMixin'

export default {
  components: {
    WarningNotification,
    BRow,
    BCol,
    BImg,
  },

  mixins: [toastification, envMixin],

  props: {
    transfer: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },

  computed: {

    isBinanceID() {
      return this.transfer.value === 'Binance User ID'
    },

    isRedotpayID() {
      return this.transfer.value === 'Redotpay ID'
    },

    usdtWallet() {
      return this.transfer.add
    },

    barCode() {
      return this.transfer.qrCodeUrl
    },
  },

  methods: {
    handleCoppy() {
      window.navigator.clipboard.writeText(this.usdtWallet).then(() => {
        this.toastSuccess(this.$t('payment.contentCopiedId'))
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.content-usdtWallet {
  overflow-wrap: break-word;
  width: 100%;
}
.text-usdtWallet {
  font-weight: 600;
}
.input {
  border: none;
}

.qbarcode {
  max-width: 172px;
  max-height: 172px;
}

.wallet-id {
  font-size: 12px;
  line-height: 1.2;
}
</style>
